/*
Adjustable Shelf Standards

  --length <float> | inches
  --durability <boolean::switch> | ['Standard', 'Heavy Duty']
*/
import { length } from '@/modules/standardItems/schemas/baseFilters'
import hardwareFilters from '@/modules/standardItems/schemas/hardware/filters'

export default [
  ...hardwareFilters,
  {
    label: 'Durability',
    value: 'durability',
    type: 'checkboxList',
    trueValue: 'Heavy Duty',
    falseValue: 'Standard'
  },
  length()
]
